class Accordion extends HTMLElement {
  connectedCallback() {
    this.accordions = this.querySelectorAll(".accordion");
    this._observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const content = entry.target;
        const intro = content.closest(".accordion")?.querySelector(".accordion__intro");
        // Sync inert and aria-expanded with actual rendered height
        const isVisible = entry.contentRect.height > 0;
        content.toggleAttribute("inert", !isVisible);
        intro?.setAttribute("aria-expanded", String(isVisible));
      }
    });

    this.accordions.forEach((accordion) => {
      const intro = accordion.querySelector(".accordion__intro");
      const content = accordion.querySelector(".accordion__content");

      intro.setAttribute("role", "button");
      intro.setAttribute("tabindex", "0");
      intro.setAttribute("aria-expanded", "false");
      content.setAttribute("inert", "");

      // ResizeObserver will correct inert/aria-expanded if CSS forces content open
      this._observer.observe(content);

      const toggle = () => {
        const isOpen = accordion.classList.contains("accordion__active");
        if (isOpen) {
          this._close(accordion);
        } else {
          this.accordions.forEach((acc) => this._close(acc));
          this._open(accordion);
        }
      };

      intro.addEventListener("click", toggle);

      intro.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          toggle();
        } else if (event.key === "Escape") {
          this._close(accordion);
          intro.focus();
        }
      });
    });
  }

  disconnectedCallback() {
    this._observer?.disconnect();
  }

  _open(accordion) {
    const content = accordion.querySelector(".accordion__content");
    accordion.classList.add("accordion__active");
    content.style.maxHeight = content.scrollHeight + "px";
  }

  _close(accordion) {
    const content = accordion.querySelector(".accordion__content");
    accordion.classList.remove("accordion__active");
    content.style.maxHeight = null;
  }
}

customElements.define("accordion-element", Accordion);